<div class="h36"></div>
<!--头部over-->
<div class="content fixTarget" id="content">
  <div class="mianbaoDiv padT20" style="width: 980px; margin: 0 auto;">
    <div class="floatL">您所在的位置：
      <a *ngIf="fromType == '0'" [routerLink]="['/gzEcommerceSearch']" [queryParams]="{userId: userId, userName: userName}">电商商务诚信</a>
      <a *ngIf="fromType == '1'" [routerLink]="['/gzLogisticsSearchComponent']" [queryParams]="{userId: userId, userName: userName}">物流商务诚信</a>
      》
      <a *ngIf="fromType == '0'" [routerLink]="['/information']" [queryParams]="{userId: userId, userName: userName, fromType: fromType}">电商资讯</a>
      <a *ngIf="fromType == '1'" [routerLink]="['/information']" [queryParams]="{userId: userId, userName: userName, fromType: fromType}">物流资讯</a>
      》资讯详情</div>
    <div class="floatR taRight"><a onclick="history.go(-1);">返回上一页</a></div>
    <div style="clear: both"></div>
  </div>
  <!--改-->
  <iframe id="ifr" [src]="url" frameborder="0" width="100%" style="min-height: 800px;" ></iframe>
</div>



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/information-detail/information-detail.component.html